var XPortal = XPortal || {};
XPortal.Template = (function () {
    var self = {
        latestDformat: "",
        boolean: function (format, data) {
            if (format && format.length > 0) {
                format = String(format).substr(3, format.length - 4);//exclude: {0:......}
                return format.split("|")[data ? 0 : 1];
            }
            return "<label class='mb-0 inactive'><input type=\"checkbox\" disabled=\"disabled\" " + (data ? "checked=\"checked\"" : "") + "/><span></span></label>";
        },
        date: function (format, data) {
            var rformat = "";
            if (format && format.length > 0) {
                rformat = String(format).substr(3, format.length - 4);//exclude: {0:......}
            } else rformat = "yyyy-MM-dd";
            self.latestDformat = format;
            if (data === "")
                return data;

            var xdata = moment(data).format(excludeFormatPrefix(format, "").toUpperCase());
            return xdata;
        },
        datetime: function (format, data) {
            var rformat = format;
            if (format && format.indexOf("{0:") === 0) rformat = String(format).substr(3, format.length - 4);


            var finalResult = XPortal.Utils.TransformDateTime(data, rformat, true, false, false, true, false, false);
            return finalResult;
        },
        formatDateToKendo: function (f) {
            if (!f) return f;
            f = f.replace(/Y/g, 'y').replace(/D/g, 'd');
            return f;
        },
        formatDateToMomment: function (f) {
            if (!f) return f;
            f = f.replace(/y/g, 'Y').replace(/t/g, 'T');
            f = f.replace(/(^|\W)d([^dD])/g, '$1D$2');//1 symbol 'd' =>'D'
            f = f.replace(/(^|\W)dd([^dD])/g, '$1DD$2');//2 symbol 'dd' =>'DD'
            f = f.replace(" TT", " A");
            return f;
        },
        numeral: function (dformat, idata, d, dfield, pageInfo) {
            if (idata === "") return idata;
            if (dformat && dformat.length > 0) {
                //var data = numeral(idata);
                //return data.format(dformat);
                if (dformat.substring(0, 1) == '{' && dformat.substring(dformat.length - 1) == "}")
                    return kendo.format(dformat, idata);
                return kendo.format("{0:" + dformat + "}", idata);
            }
            return idata;
        },
        todate: function (dateString, format) {
            var rformat = "";
            if (format && format.length > 0) {
                rformat = String(format).substr(3, format.length - 4);//exclude: {0:......}
            }

            var localizedVAl = XPortal.Utils.TransformDateTime(dateString, rformat, false, false, false, false);
            var date = kendo.parseDate(localizedVAl, rformat);
            if (date == null)
                return new Date(dateString);
            return date;
        },
        base64: function (iformat, data, d, fname, page) {
            if (data && data.length > 0) {
                let format = excludeFormatPrefix(iformat, "[[amount]]");
                let model = { item: d, fname: fname, node: page, data: data, amount: data && data.length > 0 ? data.length : 0, title: data && data.join && data.length > 0 ? data.join(",\n ") : "" };
                const ginf = page ? XPortal.Grid.GetGridInfoById(page) : null;
                model = Object.assign({ details: { parentInfo: null } }, ginf.kgrid ? ginf.kgrid.options.pageData : {}, model);

                format = format && format.length && format !== "[[amount]]" ? format : '<a class="download" href="/umbraco/Surface/Detail/DownloadAllAttachments?id=#=item.UniqueId#&KeyField=#=fname#&NodeId=[[nodeId]]&pinfo=#: details.parentInfo #" target="downloadFrm" title="#=title#">[[filesquantityandnames]]</a>';
                return kendo.template(self.ReplaceFormatString(format, data, d, page, fname))(model);
            }
            return "";
        },
        ReplaceFormatString: function (f, v, o, pi, fld, statisticContext) {
            const re = /\[\[([^\[][^\]\]]*)\]\]/g;
            let ms = null;
            let withReplacements = false;
            let thisField = null;
            let quantity = 0;
            while ((ms = re.exec(f)) != null) {
                withReplacements = true;
                let rfieldName = ms[1].split("|");
                let customFormat = rfieldName.length > 1 ? (rfieldName[1] || "").trim() : null;
                rfieldName = rfieldName[0];
                const lcrfieldName = (rfieldName || "").toLowerCase();
                const rfieldOpts = (o && o.Fields ? o.Fields.find(x => ((x.Name || x.name) || "").toLowerCase() == lcrfieldName) : null) || {};
                const rfieldDtype = rfieldOpts.ftype || rfieldOpts.Type;
                customFormat = customFormat ? customFormat : (rfieldDtype ? self.GetObjPropValueByName(XPortal.Account.dataFormats, rfieldDtype) : customFormat);
                let vtoreplace = null;
                if (lcrfieldName == "value") vtoreplace = v;
                else if (lcrfieldName == "lvalue") vtoreplace = v ? v.toLowerCase() : v;
                else if (lcrfieldName == "uvalue") vtoreplace = v ? v.toUpperCase() : v;
                else if (lcrfieldName == "newguid") vtoreplace = XPortal.Utils.guid();
                else if (lcrfieldName == "nodeid") vtoreplace = pi;
                else if (lcrfieldName == "breadcrumblink") { vtoreplace = encodeURIComponent(XPortal.EditForm.PrepareBCstring(null, window.location.href)); }
                else if (lcrfieldName == "filesquantity") { vtoreplace = self.GetFilesQuantity(o[fld]) + '&nbsp;&nbsp;'; }
                else if (lcrfieldName == "filesquantityandnames" || lcrfieldName == "filesnames") {
                    thisField = self.GetObjPropValueByName(o, fld);
                    quantity = self.GetFilesQuantity(thisField);
                    vtoreplace = v;

                    if (typeof thisField !== 'undefined') {
                        var newVtoreplace = typeof thisField === 'string'
                            ? thisField.split(thisField.indexOf('_#_') > -1 ? '_#_' : ',').map(function (field) { return XPortal.UploadFiles.AdjustFileNameBeforeRender({ name: field }); })
                            : thisField.map(function (field) { return XPortal.UploadFiles.AdjustFileNameBeforeRender({ name: field }); });

                        vtoreplace = typeof newVtoreplace === 'string'
                            ? newVtoreplace
                            : newVtoreplace.join(', ');
                    }
                    if (quantity > 0 && typeof vtoreplace !== 'undefined' && vtoreplace !== '') {
                        vtoreplace = lcrfieldName == "filesnames" ? vtoreplace : quantity + '&nbsp;&nbsp;' + vtoreplace;
                    }
                }
                else if (lcrfieldName == "filesnames") {
                    thisField = o[fld];
                    vtoreplace = v;
                    if (typeof thisField !== 'undefined') {
                        var newVtoreplace = typeof thisField === 'string'
                            ? thisField.split(thisField.indexOf('_#_') > -1 ? '_#_' : ',').map(function (field) { return XPortal.UploadFiles.AdjustFileNameBeforeRender({ name: field }); })
                            : thisField.map(function (field) { return XPortal.UploadFiles.AdjustFileNameBeforeRender({ name: field }); });
                        vtoreplace = typeof newVtoreplace === 'string' ? newVtoreplace : newVtoreplace.join(', ');
                    }
                }
                else if (o != null) {
                    vtoreplace = o[self.GetObjPropName(o, rfieldName)];
                    re.lastIndex = 0;
                    if (vtoreplace == null && rfieldName && rfieldName.length > 0) {
                        rfieldName = rfieldName.toLowerCase();
                        var fx = _.find(o.Fields, function (f) { return f.Name && f.Name.toLowerCase() == rfieldName; });
                        if (fx != null) vtoreplace = fx.StringValue;
                    }
                }

                if (vtoreplace == null) vtoreplace = '';
                if (vtoreplace instanceof Date || (rfieldDtype && rfieldDtype.toLowerCase().indexOf("date") > -1)) {
                    var dFunc = rfieldDtype && rfieldDtype.toLowerCase().includes("time") ? self.datetime : self.date;
                    vtoreplace = dFunc(customFormat || self.latestDformat, vtoreplace);
                }
                else if (!isNaN(Number(vtoreplace)) && customFormat) vtoreplace = kendo.toString(Number(vtoreplace), customFormat);
                f = f.replace(ms[0], vtoreplace);
                if (statisticContext && statisticContext.values) statisticContext.values.push(vtoreplace);
                if (statisticContext && statisticContext.names) statisticContext.names.push(lcrfieldName);
                re.lastIndex = 0; //reset index since f is changed
            }
            if (withReplacements && f.length > 2 && f.substr(0, 3) == "{0:") f = String(f).substr(3, f.length - 4);
            if (f && f.indexOf('\\"') > -1) f = f.replace(/\\"/g, '"');//fix for encoding issue
            if (f && f.indexOf("\\'") > -1) f = f.replace(/\\'/g, "'");//fix for encoding issue
            return f;
        },
        ApplyKendoTemplate: function (data, ktemplate) {
            if (!ktemplate || !data || ktemplate.length < 1) return ktemplate;
            var kindex = ktemplate.indexOf("#=");
            var kindex = kindex > -1 ? kindex : ktemplate.indexOf("#:");
            if (kindex > -1 && ktemplate.indexOf("#", kindex + 1) > kindex)
                try {
                    return kendo.template(ktemplate)(data);//apply kendo template     
                } catch (e) {
                    console.error("can't apply kendo template.", e, { ktemplate, data });
                    return e.name + ": " + e.message;
                }
            return ktemplate;
        },
        TemplateToHtml: function (obj, htmlTemplate, nodeId, dfield, dfieldval, statisticContext) {
            var res = $('<textarea />').html((htmlTemplate || "").trim()).text();//decode html;
            if (res && (res.indexOf("[[") >= 0 || res.indexOf("##") >= 0))
                res = XPortal.Template.ReplaceFormatString(res, dfieldval || "", obj, nodeId, dfield || "-", statisticContext);
            if (res && (res.indexOf("#=") >= 0 || res.indexOf("#:") >= 0))
                res = XPortal.Template.ApplyKendoTemplate(obj, res);
            return res;
        },
        GetObjPropName: function (obj, key) {
            if (!key || !obj) return null;
            const lkey = key.toLowerCase();
            for (var oi in obj)
                if (oi.toLowerCase() === lkey) return oi;
            return key;
        },
        GetObjPropValueByName: function (obj, key) {
            var name = self.GetObjPropName(obj, key);
            if (name && obj.hasOwnProperty(name))
                return obj[name];
            return null;
        },
        GetFilesQuantity: function (thisField) {
            var multiSelectFieldQty;
            if (typeof thisField !== 'undefined') {
                multiSelectFieldQty = typeof thisField === 'string' ? 1 : thisField.length;
                if (multiSelectFieldQty === 1) {
                    multiSelectFieldQty = thisField.split(thisField.indexOf('_#_') > -1 ? '_#_' : ',').length;
                }
            }

            return multiSelectFieldQty;
        },
        PatchFilterStrValue: function (expression) {
            var normalizedfirst = XPortal.Template.EscapeSpecialCharacters(expression.substring(0, 1));
            var expr = expression.substring(1, expression.length).replace(/[^\w\d\u0400-\u04FF\u00C0-\u00FF]/g, " ");
            return normalizedfirst + expr;
        },
        EscapeSpecialCharacters: function (expression) {
            var result = Array.prototype.map.call(expression, function (x) {
                if (x === '+' || x === '-' || x === '!' || x === '(' || x === ')' ||
                    x === '{' || x === '}' || x === '[' || x === ']' || x === '^' ||
                    x === '"' || x === '~' || x === '*' || x === '?' || x === ':' || x === '\\')
                    return "\\" + x;
                else return x;
            });
            return result.join("");
        }
    };
    var excludeFormatPrefix = function (format, dformat) {
        if (!format || format.length < 1) return dformat;
        if (format.substr(0, 3) == "{0:") return format.substr(3, format.length - 4);//exclude: {0:......}
        return format;
    };
    return self;
}());

